export default "__VITE_ASSET__c5c90f4f__"